import path from 'path-browserify'
import zipValidator from './zip-validator.js'
import i18n from '@/lang'

/**
 * validateFrameSequence
 * @param {{oldFiles: string[], files: string[]}} param0
 */
export const validateLanguage = ({ files, oldFiles }) => {
  const countOfFilesInZip = oldFiles.length
  return zipValidator([
    {
      rule: 'length', // 文件个数限制
      files,
      length: countOfFilesInZip,
      message: `${i18n.t(
        'playTurbo.creative.validator.message1'
      )}${countOfFilesInZip}`
    },
    {
      files,
      validate: ({ files }) => {
        // 文件命名必须与原来保持一直
        const valid = files.every(file => {
          if (typeof file === 'string') {
            return oldFiles.some(item => {
              return (
                typeof item === 'string' &&
                path.parse(item).name === path.parse(file).name
              )
            })
          }
          return false
        })
        if (valid) {
          return true
        }
        return {
          message: i18n.t('playTurbo.creative.validator.message2')
        }
      }
    }
  ])
}

/**
 * validateFrameSequence
 * @param {{oldFiles: string[], files: string[], count: number}} param0
 */
export const validateFrameSequence = ({ files, oldFiles, count }) => {
  const countOfFilesInZip = count || oldFiles.length
  return zipValidator([
    {
      rule: 'length', // 文件个数限制
      files,
      length: countOfFilesInZip,
      message: `${i18n.t(
        'playTurbo.creative.validator.message3'
      )}${countOfFilesInZip}`
    },
    {
      rule: 'pattern', // 文件命名限制，文件名字末尾必须是数字
      pattern: /\d+$/,
      files,
      message: i18n.t('playTurbo.creative.validator.message4')
    }
  ])
}

/**
 * validateDragonBones
 * @param {{oldFiles: string[], files: string[], count: number, type: number}} param0
 */
export const validateDragonBones = ({ files, oldFiles, count, type }) => {
  const countOfFilesInZip = count || oldFiles.length
  return zipValidator([
    {
      rule: 'length', // 文件个数限制
      files,
      length: countOfFilesInZip,
      message: `${i18n.t(
        'playTurbo.creative.validator.message5'
      )}${countOfFilesInZip}`
    },
    {
      files,
      validate: ({ files }) => {
        // const prefix = files.map(file => {
        //   const name = path.parse(file).name.split('_')
        // })
        // 龙骨文件格式
        // lg_type: 1
        // **_ske.json,  **_tex.json, **_tex.png
        // lg_type: 2，PlaySmart 产出的龙骨文件
        // **.ani,  **.json, **.png
        // lg_type: 3
        // **.sk, **.png

        if (type === 1 && files.length === 3) {
          const filterFiles = files.filter(item => {
            return (
              typeof item === 'string' &&
              /(_ske.json)|(_tex.json)|(_tex.png)$/.test(item)
            )
          })
          const valid =
            filterFiles.some(item => /_ske.json$/.test(item)) &&
            filterFiles.some(item => /_tex.json$/.test(item)) &&
            filterFiles.some(item => /_tex.png$/.test(item))

          if (filterFiles.length === 3 && valid) return true

          return {
            message: i18n.t(
              'playTurbo.creative.validator.dragonBones.errors[0]'
            )
          }
        }

        if (type === 2 && files.length === 3) {
          const filterFiles = files.filter(item => {
            return (
              typeof item === 'string' && /(.ani)|(.json)|(.png)$/.test(item)
            )
          })
          const valid =
            filterFiles.some(item => /.ani$/.test(item)) &&
            filterFiles.some(item => /.json$/.test(item)) &&
            filterFiles.some(item => /.png$/.test(item))

          if (filterFiles.length === 3 && valid) return true
          return {
            message: i18n.t(
              'playTurbo.creative.validator.dragonBones.errors[1]'
            )
          }
        }

        if (type === 3 && files.length === 2) {
          const filterFiles = files.filter(item => {
            return typeof item === 'string' && /(.sk)|(.png)$/.test(item)
          })
          const valid =
            filterFiles.some(item => /.sk$/.test(item)) &&
            filterFiles.some(item => /.png$/.test(item))

          if (filterFiles.length === 2 && valid) return true
          return {
            message: i18n.t(
              'playTurbo.creative.validator.dragonBones.errors[2]'
            )
          }
        }

        return {
          message: i18n.t(
            'playTurbo.creative.validator.dragonBones.defaultError'
          )
        }
      }
    }
  ])
}
